import { array, arrayOf, boolean, shape, string } from 'prop-types'

import { footerLinksType } from 'views/utils/propTypes/footerLinks'
import { MainCategoriesType } from 'views/utils/propTypes/mainCategories'

const registrationShape = shape({
  logos: arrayOf(
    shape({
      alt: string.isRequired,
      href: string.isRequired,
      id: string.isRequired,
    }).isRequired
  ).isRequired,
  uniqueSellingPoints: arrayOf(string.isRequired).isRequired,
})

const friendlyCaptchaShape = shape({
  siteKey: shape({
    contact: string.isRequired,
  }).isRequired,
})

export const publicConfigType = {
  api: shape({ baseURL: string.isRequired }),
  cdnUrl: string.isRequired,
  currencySymbolRight: boolean,
  deviceClass: string,
  featureFlags: shape({}),
  footerLinks: footerLinksType,
  friendlyCaptcha: friendlyCaptchaShape,
  gtmId: string,
  iconLinksLogos: arrayOf(shape({ id: string.isRequired }).isRequired),
  language: string.isRequired,
  locale: string.isRequired,
  logoProps: shape({}),
  mainCategories: MainCategoriesType.isRequired,
  menubarCategories: array.isRequired,
  mountPoints: shape({}).isRequired,
  nowWidget: shape({}),
  onlineDoctorConfig: shape({}),
  registration: registrationShape.isRequired,
  searchConfig: shape({}),
  shopDomain: string.isRequired,
  shopName: string.isRequired,
  shopURL: string.isRequired,
  staticImageUrl: string.isRequired,
  tenant: string.isRequired,
}
